import { ThemeProvider } from '../ThemeProvider';
import { showThriventBankModalAtom } from './ThriventBankModal.atom';
import ThriventBankModalStyles from './ThriventBankModal.style';
import { ThriventBankModalText } from './ThriventBankModalText';
import {
  CloseButton,
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@thrivent-web/ui/atoms';
import { useAtom } from 'jotai';

const ThriventBankModal = () => {
  const { Title, Body, Content, FooterButton } = ThriventBankModalStyles;
  const [open, setOpen] = useAtom(showThriventBankModalAtom);

  const closeModal = () => {
    setOpen(false);
  };

  const url = 'https://access.thriventbank.com';

  return (
    <ThemeProvider>
      <Dialog
        open={!!open}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            closeModal();
          }
        }}
      >
        <Content onEscapeKeyDown={closeModal} size="large" zIndex={598}>
          <DialogHeader>
            <DialogTitle>
              <Title as="div">Leaving Thrivent</Title>
            </DialogTitle>
            <CloseButton onClick={closeModal} />
          </DialogHeader>
          <Body>
            <ThriventBankModalText />
          </Body>
          <DialogFooter>
            <FooterButton href={typeof open === 'string' ? open : url}>
              Visit Thrivent Bank
            </FooterButton>
          </DialogFooter>
        </Content>
      </Dialog>
    </ThemeProvider>
  );
};

export default ThriventBankModal;
